import { ShoppingBag } from "lucide-react";

/**
 * "Kingdom Supporter" badge — awarded automatically when a member's email
 * appears on a paid Shopify order webhook.
 *
 * Variants:
 *   size="sm" — compact pill (next to a tier badge)
 *   size="lg" — celebratory card (used on the supporter's own profile)
 */
export default function KingdomSupporterBadge({ size = "sm", since, ordersCount }) {
  if (size === "lg") {
    return (
      <div className="jj-card mt-6 p-6 sm:p-7 bg-gradient-to-br from-cream to-gold/10 ring-1 ring-[var(--jj-gold)]/50" data-testid="kingdom-supporter-card">
        <div className="flex items-start gap-4 flex-wrap">
          <span className="h-11 w-11 rounded-2xl bg-gold/20 text-burgundy flex items-center justify-center shrink-0">
            <ShoppingBag className="h-5 w-5" strokeWidth={1.6} />
          </span>
          <div className="flex-1 min-w-[220px]">
            <div className="overline text-burgundy">Kingdom Supporter</div>
            <h3 className="font-serif text-2xl text-jjblue mt-1 leading-tight">Your name is on a piece of the Kingdom.</h3>
            <p className="mt-2 text-sm text-[var(--jj-text-secondary)] leading-relaxed">
              Thank you for sowing into the Shop. Every order funds the prayer circles, the testimonies,
              and the elders we&rsquo;re learning to love.
              {since ? <> Supporter since <span className="text-jjblue/90">{new Date(since).toLocaleDateString(undefined, { month: "long", year: "numeric" })}</span>.</> : null}
              {ordersCount ? <> {ordersCount} order{ordersCount === 1 ? "" : "s"} and counting.</> : null}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold bg-gold/20 text-burgundy px-2 py-0.5 rounded-full"
      title={since ? `Kingdom Supporter since ${new Date(since).toLocaleDateString()}` : "Kingdom Supporter"}
      data-testid="kingdom-supporter-badge"
    >
      <ShoppingBag className="h-3 w-3" strokeWidth={2} /> Supporter
    </span>
  );
}
